"use strict";
var appn;
(function (appn) {
    var designerv2;
    (function (designerv2) {
        function getPropertyByPath(obj, path) {
            return path.split('.').reduce((o, k) => (o || {})[k], obj);
        }
        designerv2.getPropertyByPath = getPropertyByPath;
        function setPropertyByPath(obj, path, value) {
            const keys = path.split('.');
            let current = obj;
            for (let i = 0; i < keys.length - 1; i++) {
                if (current[keys[i]] === undefined || current[keys[i]] === null)
                    current[keys[i]] = {};
                current = current[keys[i]];
            }
            current[keys[keys.length - 1]] = value;
        }
        designerv2.setPropertyByPath = setPropertyByPath;
        function hookCheckboxHandler($editor, checkboxSelector, onCheckedChanged) {
            const $checkbox = $editor.find(checkboxSelector);
            if (!$checkbox.length)
                return;
            $checkbox.closest('.icheck-primary.appn-checkbox').on('click', (e) => {
                e.preventDefault();
                const isCurrentlyChecked = $checkbox.prop('checked');
                const newState = !isCurrentlyChecked;
                onCheckedChanged(newState);
            });
        }
        designerv2.hookCheckboxHandler = hookCheckboxHandler;
        function findDiff(prev, current, path = '', changes = {}) {
            const allKeys = new Set([...Object.keys(prev), ...Object.keys(current)]);
            const isParentArray = Array.isArray(prev);
            for (const key of allKeys) {
                const currentPath = isParentArray ? `${path}[${key}]` : (path ? `${path}.${key}` : key);
                const prevValue = prev[key];
                const currentValue = current[key];
                const prevType = typeof prevValue;
                const currentType = typeof currentValue;
                const isPrevObject = prevType === 'object' && prevValue !== null;
                const isCurrentObject = currentType === 'object' && currentValue !== null;
                const isPrevArray = Array.isArray(prevValue);
                const isCurrentArray = Array.isArray(currentValue);
                if (!(key in current)) {
                    changes[currentPath] = { type: 'deleted', oldValue: prevValue };
                    continue;
                }
                if (!(key in prev)) {
                    changes[currentPath] = { type: 'added', newValue: currentValue };
                    continue;
                }
                if (isPrevObject && isCurrentObject) {
                    if ((isPrevArray && isCurrentArray) || (!isPrevArray && !isCurrentArray)) {
                        findDiff(prevValue, currentValue, currentPath, changes);
                        continue;
                    }
                }
                if (JSON.stringify(prevValue) !== JSON.stringify(currentValue)) {
                    changes[currentPath] = { type: 'changed', oldValue: prevValue, newValue: currentValue };
                }
            }
            return changes;
        }
        function logDiffToConsole(prev, current) {
            const diff = findDiff(prev, current);
            const changeKeys = Object.keys(diff);
            if (changeKeys.length === 0) {
                console.log('%c[Diff Logger] No changes detected.', 'color: #10b981; font-weight: bold;');
                return;
            }
            console.group(`%c[Diff Logger] State Change Detected: ${changeKeys.length} changes`, 'color: #4f46e5; font-weight: bold; background: #eef2ff; padding: 4px 6px; border-radius: 4px;');
            for (const path of changeKeys) {
                const { type, oldValue, newValue } = diff[path];
                let logStyle = '';
                let typeLabel = '';
                switch (type) {
                    case 'added':
                        logStyle = 'color: #10b981; font-weight: bold;';
                        typeLabel = 'ADDED';
                        console.log(`%c${typeLabel}: ${path} (New Value: ${JSON.stringify(newValue, null, '  ')})`, logStyle);
                        break;
                    case 'deleted':
                        logStyle = 'color: #ef4444; font-weight: bold;';
                        typeLabel = 'DELETED';
                        console.log(`%c${typeLabel}: ${path} (Old Value: ${JSON.stringify(oldValue, null, '  ')})`, logStyle);
                        break;
                    case 'changed':
                        logStyle = 'color: #f97316; font-weight: bold;';
                        typeLabel = 'CHANGED';
                        console.log(`%c${typeLabel}: ${path}: ${JSON.stringify(oldValue, null, '  ')} -> ${JSON.stringify(newValue, null, '  ')}`, logStyle);
                        break;
                }
            }
            console.groupEnd();
        }
        designerv2.logDiffToConsole = logDiffToConsole;
    })(designerv2 = appn.designerv2 || (appn.designerv2 = {}));
})(appn || (appn = {}));
